import clsx from 'clsx';
import { ReactNode } from 'react';
import { renderHeaderTag } from '../../lib/constants';

interface Props extends BaseProps {
  border?: boolean;
  children?: ReactNode;
  headerTag?: HeaderTags;
  fontSize?: StandardSizes;
  inlinePadding?: StandardSizes | 'none';
  text?: string;
}

export const SectionHeader = (props: Props) => {
  const {
    border = true,
    className,
    children = null,
    fontSize = 'md',
    headerTag,
    inlinePadding = 'sm',
    text = null,
    ...rest
  } = props;
  const classes = useStyles();

  if (!children && !text)
    throw new Error('SectionHeader must have text or children');

  const renderHeader = () => {
    if (children) return children;
    if (!text) return;
    return renderHeaderTag(text, headerTag, fontSize);
  };

  return (
    <div
      className={clsx(
        className,
        classes.default,
        classes.inlinePadding[inlinePadding],
        { [classes.border]: border }
      )}
      {...rest}
    >
      {renderHeader()}
    </div>
  );
};

const useStyles = () => ({
  border: 'border-b border-border-light dark:border-border-dark',
  default: 'block py-1',
  inlinePadding: {
    none: 'px-0',
    sm: 'px-1',
    md: 'px-2',
    lg: 'px-4',
  },
});
